<template>
  <div class="one-input" :class="{'one-input_suffix':clearabled}">
    <input
      :type="type"
      class="one-input_inner"
      :class="{ 'is-disabled': disabled }"
      :placeholder="placeholder"
      :disabled="disabled"
      :name="name"
      :value="value"
      @input="handleInput"
      :clearabled="clearabled"
    />

    <span class="one-input_suffix" v-if="clearabled && value">
      <i class="on-input_icon one-icon-cancel" @click="clear"></i>
    </span>
  </div>
</template>
<script>
export default {
  name: "one-input",
  props: {
    type: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    clearabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e.target.value);
    },
    clear(){
      this.$emit("input",""); 
    }
  },
};
</script>
<style scoped lang="scss">
.one-input {
  width: 180px;
  position: relative;
  font-size: 14px;
  display: inline-block;
  .one-input_inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 045, 0.355, 1);
    width: 100%;
    margin-bottom: 20px;
    &:focus {
      outline: none;
      border-color: #409eff;
    }
    // input禁用样式
    &.is-disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
// 后面加suffix的意思是后面如果有后缀的话，触发该样式
.one-input_suffix {
  .one-input_inner {
    padding-right: 30px;
  }
  .one-input_suffix {
    position: absolute;
    right: 10px;
    height: 100%;
    top: 0;
    line-height: 40px;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    z-index: 900;
    i {
      color: #c0c4cc;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
}
</style>